export default __webpack_public_path__ + "static/media/Hero-Picture 4 - without text.9e11a1fd.jpg";